/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModelClassEnum } from './ModelClassEnum';
import { ModelClassEnumFromJSON, ModelClassEnumFromJSONTyped, ModelClassEnumToJSON } from './ModelClassEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';

/**
 *
 * @export
 * @interface PerturbedTabularMLDataset
 */
export interface PerturbedTabularMLDataset {
  /**
   *
   * @type {number}
   * @memberof PerturbedTabularMLDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedTabularMLDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedTabularMLDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedTabularMLDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedTabularMLDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {ModelClassEnum}
   * @memberof PerturbedTabularMLDataset
   */
  modelClass: ModelClassEnum;
}

/**
 * Check if a given object implements the PerturbedTabularMLDataset interface.
 */
export function instanceOfPerturbedTabularMLDataset(value: object): value is PerturbedTabularMLDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('modelClass' in value) || value['modelClass'] === undefined) return false;
  return true;
}

export function PerturbedTabularMLDatasetFromJSON(json: any): PerturbedTabularMLDataset {
  return PerturbedTabularMLDatasetFromJSONTyped(json, false);
}

export function PerturbedTabularMLDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedTabularMLDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    modelClass: ModelClassEnumFromJSON(json['model_class']),
  };
}

export function PerturbedTabularMLDatasetToJSON(
  value?: Omit<PerturbedTabularMLDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    model_class: ModelClassEnumToJSON(value['modelClass']),
  };
}
